//
import axios from "axios";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [StruttureMixin],
	data() {
		return {
			contabilitaSoggetti: [],
			contabilitaSoggettiOptions: [],
			contabilitaSoggettiPathResources: "/contabilitasoggetti",
			contabilitaSoggettoAltriIndirizziRighe: [],
			contabilitaSoggettoAltriIndirizziOptions: [],
			contabilitaSoggettoAltriIndirizziPathResources: "/contabilitasoggettoaltriindirizzi",
			filtroContabilitaSoggetti: {},
		};
	},
	methods: {
		contabilitaSoggettiLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaSoggettiPathResources;
			axios.get(link, { params: this.filtroContabilitaSoggetti })
				.then((response) => {
					this.contabilitaSoggetti = response.data.data.list;
					this.contabilitaSoggettiOptions = this.contabilitaSoggetti;
				})
				.catch((error) => {
					this.$bvModal
						.msgBoxOk(error.response.data.messaggio, {
							title: "ATTENZIONE",
							size: "sm",
							okVariant: "outline-danger",
							headerClass: "sa-msg-header-danger",
							footerClass: "p-2 border-top-0",
							centered: true,
						})
						.then((value) => {
							this.boxTwo = value;
						})
						.catch((err) => {
							console.log(err);
						});
				});
		},
		contabilitaSoggettoAltriIndirizziLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaSoggettoAltriIndirizziPathResources;
			this.contabilitaSoggettoAltriIndirizziOptions = [];
			axios.get(link)
				.then((response) => {
					this.contabilitaSoggettoAltriIndirizziOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
	},
};
